import Vue from 'vue'
import Router from 'vue-router'
import VueAnalytics from 'vue-analytics'
import store from '~store'

import {
  capitalize
} from '../utils/string'

import { getToken } from '~utils/auth'

Vue.use(Router)

const pages = {}
const routes = [{
  path: '/',
  redirect: '/home',
  meta: {}
}]
const contextMiddleware = require.context('../middleware', false, /\.js$/)
const contextPages = require.context('../pages', true, /\.vue$/)
const requireFiles = context => context.keys()
const requireModules = context => context.keys().map(context)
const files = requireFiles(contextPages)
const components = requireModules(contextPages).map(component => component.default)
const middleware = requireFiles(contextMiddleware).map(mid => mid.replace(/(\.\/|\.js)/g, ''))
const middlewareModules = requireModules(contextMiddleware)

files.forEach(filename => {
  if (filename === './index.vue' || filename === './App.vue') {
    return
  }

  const pathName = '/'.concat(filename.replace(/(^\.\/|(\/index)?\.vue)/g, '')).replace(/(_)/g, ':')
  const pageName = pathName.split('/').reduce((accumulator, currentValue) => accumulator.concat(capitalize(currentValue)), '')
  const component = components.find(component => component.routerName === pageName)
  const meta = {}

  if (Object.keys(component).includes('middleware')) {
    meta.middleware = component.middleware
  }

  pages[pageName] = routes[routes.length] = {
    name: pageName,
    path: pathName,
    component: {
      ...component
    },
    meta
  }
})

const router = new Router({
  routes: routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  let redirectName = null
  const hasFromMid = Object.keys(from.meta).includes('middleware')
  const hasToMid = Object.keys(to.meta).includes('middleware')

  if (hasFromMid) {
    if (from.meta.middleware.includes('leave-page')) {
      const index = middleware.indexOf('leave-page')
      redirectName = middlewareModules[index].default({
        store, from, to
      })
    }
  }

  if (hasToMid) {
    to.meta.middleware.forEach(mid => {
      const index = middleware.indexOf(mid)
      redirectName = middlewareModules[index].default({
        store, from, to
      })
    })
  }

  store.dispatch('layouts/resetModal')
  getToken()

  if (redirectName) {
    if (redirectName.name !== from.name) {
      const timeOut = hasFromMid ? 3500 : 100
      setTimeout(() => {
        redirectName ? router.replace(redirectName) : next()
      }, timeOut)
    }
  } else {
    next()
  }
})

if (window.location.host === 'career.ntust.edu.tw') {
  Vue.use(VueAnalytics, {
    id: 'UA-145657652-1',
    router
  })
}

export default router
